import { AuthUser } from '../../context/AuthContext';

/**
 * Get display name for user, falling back through multiple options
 */
export function getUserDisplayName(user: AuthUser | null): string {
  if (!user) return '';

  if (typeof user.display_name === 'string' && user.display_name.trim()) {
    return user.display_name.trim();
  }

  const first = typeof user.first_name === 'string' ? user.first_name.trim() : '';
  const last = typeof user.last_name === 'string' ? user.last_name.trim() : '';
  const parts = [first, last].filter(Boolean);

  if (parts.length) {
    return parts.join(' ');
  }

  return typeof user.email === 'string' ? user.email : '';
}

/**
 * Derive a consistent user handle used for mentions and tooltips.
 * Preference order: username, display name, email local part, user id.
 */
export function getUserHandle(user: AuthUser | null): string {
  if (!user) return '';

  const sources: Array<string | undefined> = [
    typeof user.username === 'string' ? user.username : undefined,
    typeof user.display_name === 'string' ? user.display_name : undefined,
    typeof user.email === 'string' ? user.email.split('@')[0] : undefined,
    typeof user.first_name === 'string' ? `${user.first_name}${user.last_name ?? ''}` : undefined,
    typeof user.id === 'string' ? user.id : undefined,
  ];

  const raw = sources
    .map((value) => (typeof value === 'string' ? value.trim() : ''))
    .find((value) => value.length > 0);

  if (!raw) {
    return '';
  }

  return raw
    .replace(/\s+/g, '')
    .replace(/[^a-zA-Z0-9_.-]/g, '')
    .toLowerCase();
}








